export const logTypes = ['Device', 'Slide', 'Presentation', 'Asset', 'User'];
